import React, { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";
import { apiError, fmtD } from "@/lib/platform";
import { Panel } from "@/components/rights/RightsBadges";

const Item = ({ k, children, testId }) => (
  <div className="grid grid-cols-[110px_1fr] gap-2 py-1.5 text-xs">
    <span className="text-slate-500">{k}</span>
    <span className="text-[#003366] font-medium break-words" data-testid={testId}>{children || "—"}</span>
  </div>
);

export const RequestSummary = ({ r, meta, users, canEdit, onChanged }) => {
  const [target, setTarget] = useState(r.target_date);
  const editable = canEdit && r.status !== "CLOSED";
  const patch = async (body, msg) => {
    try {
      await api.patch(`/rights/${r.id}`, body);
      toast.success(msg);
      onChanged();
    } catch (e) { toast.error(apiError(e, "Update failed")); setTarget(r.target_date); }
  };
  return (
    <Panel eyebrow={`Work item ${r.work_item?.reference_number}`} title="Request details" testId="request-summary">
      <Item k="Owner" testId="summary-owner">
        {editable ? (
          <Select value={r.owner} onValueChange={(v) => patch({ owner: v }, `Owner changed to ${v}`)}>
            <SelectTrigger className="h-8 text-xs" data-testid="summary-owner-select"><SelectValue /></SelectTrigger>
            <SelectContent>{users.map((u) => <SelectItem key={u.username} value={u.username}>{u.full_name || u.username}</SelectItem>)}</SelectContent>
          </Select>
        ) : r.owner}
      </Item>
      <Item k="Received" testId="summary-received">{fmtD(r.received_date)} · {meta.channels[r.channel]}</Item>
      <Item k="Target date" testId="summary-target">
        {editable ? (
          <Input type="date" value={target} className="h-8 text-xs" data-testid="summary-target-input"
                 onChange={(e) => setTarget(e.target.value)}
                 onBlur={() => target !== r.target_date && patch({ target_date: target }, "Target date updated")} />
        ) : fmtD(r.target_date)}
      </Item>
      <Item k="Subject" testId="summary-subject">{r.subject_name} ({r.subject_type_label})</Item>
      <Item k="Person key" testId="summary-person-key"><span className="font-mono">{r.linked_person_key}</span></Item>
      <Item k="Email" testId="summary-email">{r.subject_email}</Item>
      <Item k="Mobile" testId="summary-phone">{r.subject_phone}</Item>
      {r.nominee && (
        <Item k="Nominee" testId="summary-nominee">
          {r.nominee.name}{r.nominee.relationship && ` · ${r.nominee.relationship}`}{r.nominee.email && ` · ${r.nominee.email}`}
        </Item>
      )}
      <Item k="Responded" testId="summary-responded">{r.responded_at ? fmtD(r.responded_at) : null}</Item>
      {r.description && <p className="text-xs text-slate-600 mt-2 pt-2 border-t border-slate-100 whitespace-pre-wrap">{r.description}</p>}
    </Panel>
  );
};
